export interface IAssociatedClient {
  clientId?: string;
  name?: string;
  surname?: string;
  email?: string;
}

export class AssociatedClient implements IAssociatedClient {
  clientId?: string;
  name?: string;
  surname?: string;
  email?: string;

  constructor(data?: IAssociatedClient) {
    this.clientId = data?.clientId;
    this.name = data?.name;
    this.surname = data?.surname;
    this.email = data?.email;
  }

  static empty = () => {
    return new AssociatedClient({
      clientId: undefined,
      name: undefined,
      surname: undefined,
      email: undefined
    });
  };

  static from = (data: IAssociatedClient[]): AssociatedClient[] => {
    return data.map(associatedClient => new AssociatedClient(associatedClient));
  };

  isComplete = () => {
    return !!(this.clientId && this.name && this.surname && this.email);
  };

  setClientData = (client: IAssociatedClient) => {
    this.clientId = client.clientId;
    this.name = client.name;
    this.surname = client.surname;
    this.email = client.email;
  };
}

export class AssociatedClients extends Array<AssociatedClient> {
  constructor(data: AssociatedClient[]) {
    super(...data);
  }

  static empty = () => {
    return new AssociatedClients([]);
  };

  static from = (data: IAssociatedClient[]): AssociatedClients => {
    return new AssociatedClients(data.map(associatedClient => new AssociatedClient(associatedClient)));
  };

  areAllComplete = (): boolean => {
    return this.every(associatedClient => associatedClient.isComplete());
  };

  getCompleteClients = (): AssociatedClients => {
    return new AssociatedClients(this.filter(associatedClient => associatedClient.isComplete()));
  };

  getIncompleteClients = (): AssociatedClients => {
    return new AssociatedClients(this.filter(associatedClient => !associatedClient.isComplete()));
  };

  findByClientId = (clientId: string): AssociatedClient => {
    return this.find(associatedClient => associatedClient.clientId === clientId);
  };

  setAssociatedClients = (clients: IAssociatedClient[]) => {
    this.forEach(associatedClient => {
      const client = clients.find(c => c.clientId === associatedClient.clientId);
      if (client) {
        associatedClient.setClientData(client);
      }
    });
  };
}
